import translate from "@insite/client-framework/Translate";
import Clickable from "@insite/mobius/Clickable/Clickable";
import Hidden from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import HeaderSearch from "@midland-industries/Components/Header/HeaderSearch";
import Stack from "@midland-industries/Components/Stack";
import IconKey from "@midland-industries/Icons/IconKey";
import IconShoppingCart from "@midland-industries/Icons/IconShoppingCart";
import IconUser from "@midland-industries/Icons/IconUser";
import IconUserPlus from "@midland-industries/Icons/IconUserPlus";
import { colors } from "@midland-industries/Styles/colors";
import React from "react";

interface HeaderProps {
    userName: string;
    currentUserIsGuest: boolean;
    cartUrl: string;
    cartCount: number;
    onSignInHandler: (e: React.MouseEvent) => void;
}

const Header: React.FC<HeaderProps> = ({ userName, currentUserIsGuest, cartCount, cartUrl, onSignInHandler }) => {
    return (
        <Group align="center" gap={30}>
            <Link href="/">
                <Hidden below="md">
                    <Img
                        src="/staticContent/mi-logo-banner.png"
                        altText={translate("Home")}
                        width={229}
                        style={{ objectPosition: "-6px" }}
                    />
                </Hidden>
            </Link>
            <HeaderSearch />
            {userName && !currentUserIsGuest ? (
                <>
                    <Clickable href="/my-account">
                        <Stack align="center" justify="center" style={{ width: 87 }}>
                            <Icon color={colors.textAccent} src={IconUser} />
                            <Typography weight={700} size={16} color={colors.textAccent}>
                                My Account
                            </Typography>
                        </Stack>
                    </Clickable>
                    <Clickable href={cartUrl}>
                        <Stack gap={3} align="center" justify="center">
                            <Icon color={colors.midlandRed} src={IconShoppingCart} />
                            <Typography weight={700} size={16} color={colors.midlandRed}>
                                Cart({cartCount})
                            </Typography>
                        </Stack>
                    </Clickable>
                </>
            ) : (
                <>
                    <Clickable onClick={onSignInHandler}>
                        <Stack gap={3} align="center" justify="center" style={{ width: 48 }}>
                            <Icon color={colors.textAccent} src={IconKey} />
                            <Typography weight={700} size={16} color={colors.textAccent}>
                                Sign In
                            </Typography>
                        </Stack>
                    </Clickable>
                    <Clickable>
                        <Stack gap={3} align="center" justify="center" style={{ width: 133 }}>
                            <Icon color={colors.textAccent} src={IconUserPlus} />
                            <Typography weight={700} size={16} color={colors.textAccent}>
                                Create an Account
                            </Typography>
                        </Stack>
                    </Clickable>
                </>
            )}
        </Group>
    );
};

export default Header;
